export default __webpack_public_path__ + "static/hiscocase2-0209612908d5b608e8510d3eeea84870.png";